import { useState } from "react";
import { Form, Link, useRouteLoaderData } from "react-router-dom";

import { defaultService, Service } from "./types";

export default function ServiceForm({
    keyword,
}: {
    keyword: "Add" | "Edit";
}) {
    const loaderService = (useRouteLoaderData("service") as { service?: Service } | undefined)?.service ?? defaultService;
    const [formValues, setFormValues] = useState(loaderService);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Form method = "post">
            <input type = "hidden" name = "action" value = {keyword} />
            <input type = "hidden" name = "id" value = {formValues.id ?? ""} />
            <div className = "ps-3 mb-2">
                <div className = "d-flex align-items-center mt-2">
                    <label className = "fw-bold text-nowrap mb-0" htmlFor = "code">Code:</label>
                    <input
                        className = "form-control flex-grow-1 ms-3"
                        id = "code"
                        name = "code"
                        value = {formValues.code ?? ""}
                        onChange = {handleChange}
                    />
                </div>
                <div className = "d-flex align-items-center mt-2">
                    <label className = "fw-bold text-nowrap mb-0" htmlFor = "name">Name:</label>
                    <input
                        className = "form-control flex-grow-1 ms-3"
                        required
                        id = "name"
                        name = "name"
                        value = {formValues.name ?? ""}
                        onChange = {handleChange}
                    />
                </div>
                <div className = "d-flex align-items-center mt-2">
                    <label className = "fw-bold text-nowrap mb-0" htmlFor = "category">Category:</label>
                    <input
                        className = "form-control flex-grow-1 ms-3"
                        id = "category"
                        name = "category"
                        value = {formValues.category ?? ""}
                        onChange = {handleChange}
                    />
                </div>
                <div className = "d-flex align-items-center mt-2">
                    <label className = "fw-bold text-nowrap mb-0" htmlFor = "price">Price:</label>
                    <input
                        className = "form-control flex-grow-1 ms-3"
                        required
                        type = "number"
                        min = "0"
                        step = "0.01"
                        id = "price"
                        name = "price"
                        value = {formValues.price ?? ""}
                        onChange = {handleChange}
                    />
                </div>
                <div className = "d-flex align-items-center mt-2">
                    <label className = "fw-bold text-nowrap mb-0" htmlFor = "costType">Cost Type:</label>
                    <input
                        className = "form-control flex-grow-1 ms-3"
                        required
                        id = "costType"
                        name = "costType"
                        value = {formValues.costType ?? ""}
                        onChange = {handleChange}
                    />
                </div>
                <div className = "d-flex align-items-start mt-2">
                    <label className = "fw-bold text-nowrap mb-0" htmlFor = "notes">Notes:</label>
                    <textarea
                        className = "form-control flex-grow-1 ms-3"
                        id = "notes"
                        name = "notes"
                        value = {formValues.notes ?? ""}
                        onChange = {handleChange}
                        rows = {4}
                    />
                </div>
            </div>
            <div className = "my-3">
                <button type = "submit" className = "btn btn-primary">{keyword}</button>
                <Link to = ".." className = "btn btn-outline-secondary float-end">Back</Link>
            </div>
        </Form>
    );
}
